<!-- 发布服务 -->
<template>
  <div class="service-wp">
    <el-row :gutter="0" class="dashed">
      <el-col :span="12">
        <div class="grid-content bg-purple title1">发布"心愿愿望"</div>
      </el-col>
    </el-row>
    <el-row>
      <div class="service-xp">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="心愿标题：" prop="title">
            <el-col :span="10">
              <el-input v-model="ruleForm.title" placeholder="请输入心愿愿望标题" clearable maxlength="10"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="旅行金额：" prop="money">
            <el-col :span="5">
              <el-input v-model="ruleForm.money" type="number" placeholder="请输入金额" maxlength="5" clearable></el-input>
            </el-col>
            <el-col :span="1">
              元
            </el-col>
          </el-form-item>
          <el-form-item label="旅行人数：" prop="people">
            <el-col :span="10">
              <el-input-number v-model="ruleForm.people" :min="1" :max="10" label="人数"></el-input-number>人
            </el-col>
          </el-form-item>
          <el-form-item label="筹集时间：" prop="timeAll">
            <el-col :span="10">
              <el-date-picker v-model="ruleForm.timeAll" type="datetimerange" range-separator="至" clearable start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item label="封面图片：" prop="imgAll">
            <el-upload action="https://api.peibanwan.com/pbw-interface/common/uploadFileToOSS"   list-type="picture-card" :on-preview="handlePictureCardPreview" :on-success="handsuccess" :limit="1" :on-remove="handleRemove" >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="ruleForm.imgAll" alt="">
            </el-dialog>
            <!--            <el-upload-->
            <!--              class="avatar-uploader"-->
            <!--              action="https://api.peibanwan.com/pbw-interface/common/uploadFileToOSS"-->
            <!--              :show-file-list="false"-->
            <!--              :on-success="handleAvatarSuccess"-->
            <!--              :before-upload="beforeAvatarUpload">-->
            <!--              <img v-if="ruleForm.imgAll" :src="ruleForm.imgAll" class="avatar">-->
            <!--              <i v-else class="el-icon-plus avatar-uploader-icon el-border"></i>-->
            <!--            </el-upload>-->
          </el-form-item>
          <el-form-item label="心愿内容：" prop="textContent">
            <el-input type="textarea" placeholder="请输入心愿内容描述" v-model="ruleForm.textContent" clearable></el-input>
          </el-form-item>
          <el-form-item label="答谢方式：" prop="modeType">
            ①
            <el-checkbox v-model="ruleForm.modeType" label="1" border>帮忙代购商品</el-checkbox>
            <p>（再截止时间后，系统自行随机抽取一名幸运赞助者，您可帮其代购商品，费用自行商议，由您自行解决！）</p>
            <br> ②
            <el-checkbox v-model="ruleForm.modeType" label="2" border>随机抽奖1名赞助者</el-checkbox>
            礼物：
            <el-input style="width: 180px" v-model="ruleForm.typeText" placeholder="输入赠送礼物名称" clearable></el-input>
            <p>（再截止时间后，系统自行随机抽取一名幸运赞助者，您将赠送本人的礼物，由您自行承担发放!）</p>
            <br>
            <p style="color: #333;font-weight: bold">声明："答谢方式"可自由选择，并不是必选；为更好的帮助您更快的筹集到心愿愿望的费用 ，您可自行选择是否进行答谢方式，所有责任有您自行承担，请妥善选择处理。本平台不承担任何责任，本声明最终解释权归属公司所有；</p>
          </el-form-item>
          <br>
          <br>
          <br>
          <el-form-item style="text-align: center" prop="checked">
            <p>
              <el-checkbox v-model="ruleForm.checked">发布心愿表示同意<span style="color: #00aaff">《心愿愿望服务协议》</span></el-checkbox> <span @click="tcp('4')" style="color: #00aaff">(☞查看条款)</span></p>
            <el-button type="primary" @click="submitForm('ruleForm')">发布心愿愿望</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
    <!--    协议-->
    <tcp :textShow="textShow" :tcpId="tcpId"></tcp>
  </div>
</template>

<script>
  import {
    insertTravel
  } from 'api/apis'
  import tcp from '../../components/common/tcp.vue'
  export default {
    components: {
      tcp
    },
    data() {
      var modeMsg = (rule, value, callback) => {
        console.log(value, "66666")
        if (value.join(',').indexOf('2') > -1) {
          if (this.ruleForm.typeText == '') {
            callback(new Error('请输入要赠送的礼物名称'));
          }
          callback();
        } else {
          callback();
        }
      };
      return {
        textShow: false,
        tcpId: '',
        dialogVisible: false,
        ruleForm: {
          title: '', //发布标题
          money: '', //金钱
          people: 1, //人数
          timeAll: '',
          imgAll: '',
          textContent: '',
          modeType: [],
          typeText: '',
          checked: ''
        },
        rules: {
          title: [{
            required: true,
            message: '请输入心愿标题',
            trigger: 'change'
          }],
          money: [{
            required: true,
            message: '请输入旅行金额',
            trigger: 'change'
          }],
          people: [{
            required: true,
            message: '请输入人数',
            trigger: 'blur'
          }],
          timeAll: [{
            required: true,
            message: '请选择开始结束时间',
            trigger: 'blur'
          }],
          imgAll: [{
            required: true,
            message: '请上传封面图片',
            trigger: 'blur'
          }],
          textContent: [{
            required: true,
            message: '请输入内容描述',
            trigger: 'change'
          }],
          modeType: [{
            validator: modeMsg,
            trigger: 'change'
          }],
          checked: [{
            required: true,
            message: '[请勾选同意条款，后在提交]',
            trigger: 'blur'
          }],
        },
      };
    },
    methods: {
      tcp(id) {
        console.log(id)
        this.textShow = !this.textShow
        this.tcpId = id
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(Number(this.ruleForm.money).toFixed(2) < 500){
              this.$message.error('心愿金额必须大于500元')
              return
            }
            let thankMethod = ''
            if (this.ruleForm.modeType.length == 0) {
              thankMethod = 0
            } else if (this.ruleForm.modeType.length == 1) {
              thankMethod = this.ruleForm.modeType[0]
            } else {
              thankMethod = 3
            }
            insertTravel({
              title: this.ruleForm.title, //众筹标题
              travelStart: this.ruleForm.timeAll[0].getTime() / 1000, //众筹开始时间
              travelEnd: this.ruleForm.timeAll[1].getTime() / 1000, //众筹结束时间
              travelNumber: this.ruleForm.people, //众筹人数
              travelMoney: Number(this.ruleForm.money).toFixed(2), //众筹金额
              travelImg: this.ruleForm.imgAll, //众筹图片（最多六张 逗号分割）
              context: this.ruleForm.textContent, //	众筹简介
              thankMethod: thankMethod, //答谢方式（0 没有，1：帮忙代购，2：随机抽奖，3：即可代购也有奖品）
              goodsName: this.ruleForm.typeText, //答谢商品名称
              ifAgree: this.ruleForm.checked ? 2 : 1, //是否同意（1，不同意，2，同意）
            }).then((res) => {
              if (res.code == '000000') {
                this.$router.push('/home/endorsement')
                this.$message.success('心愿愿望发布成功')
              } else {
                this.$message.error(res.msg)
              }
            })
          } else {
            console.log('error submit!!', this.ruleForm);
            this.$message.error('您有未填写项，请补全后在发布')
            return false;
          }
        });
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePictureCardPreview(file) {
        this.ruleForm.imgAll = file.url;
        this.dialogVisible = true;
      },
      handsuccess(response, file, fileList) {
        this.ruleForm.imgAll = response.data.ossFileName
        console.log(response)
        console.log(file)
        console.log(fileList)
      },
      handleAvatarSuccess(res, file) {
        console.log(res, "回传成功")
        this.imageUrl = URL.createObjectURL(file.raw);
        this.ruleForm.serveCoverImg = res.data.ossFileName
      },
      beforeAvatarUpload(file) {
        // 上传格式判断
        if (!/.(jpg|jpeg|png|bmp|JPG|JPEG|PNG|BPM)$/.test(file.name)) {
          this.$message.error('文件格式只能是jpeg、jpg、PNG、bmp中的一种!')
          return false
        }
        if (file.size > 100 * 1024 * 1024) {
          this.$message.error('文件大小超过限制')
          return false
        }
        const loading = this.$loading({
          lock: true,
          text: '上传中～',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          loading.close();
        }, 1500);
      },
    },
    mounted() {
    }
  }
</script>

<!--css样式-->
<style lang="scss" scoped>
  @import '../../../src/scss/commonH5.scss';
  @import '../../scss/demo.scss';
  .quill-editor {
    height: 70%;
  }
  .avatar {
    height: 120px;
    border-radius: 90px;
    border: 1px solid #d6d6d6;
  }
  .service-wp .dashed {
    border-bottom: 1px dashed #F1F1F1;
    padding-bottom: 20px;
    margin-bottom: 25px;
  }
  .service-wp .title1 {
    font-size: 18px;
    color: #333;
  }
  .service-wp .title1::before {
    content: '';
    display: inline-block;
    width: 5px;
    height: 27px;
    border-radius: 5px;
    vertical-align: bottom;
    background-color: #F16202;
    margin-right: 20px;
  }
  .service-wp {
    .service-xp {
      width: 100%;
      margin: 0 auto;
    }
    .grid-from {
      margin-left: 10px;
    }
    .dashed {
      margin: 10px 0px;
    }
    .del-btn {
      font-size: 16px;
      color: #f60;
    }
    .avatar {
      height: 160px;
      border: 1px solid #d6d6d6;
    }
    .el-border {
      width: 160px;
      height: 160px;
      line-height: 160px;
      border: 1px solid #ddd;
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/home/endorsementAdd.vue